import type React from "react";
import {
  ContextMenu as ShadcnContextMenu,
  ContextMenuTrigger as ShadcnContextMenuTrigger,
  ContextMenuContent as ShadcnContextMenuContent,
  ContextMenuItem as ShadcnContextMenuItem,
  ContextMenuCheckboxItem as ShadcnContextMenuCheckboxItem,
  ContextMenuRadioItem as ShadcnContextMenuRadioItem,
  ContextMenuLabel as ShadcnContextMenuLabel,
  ContextMenuSeparator as ShadcnContextMenuSeparator,
  ContextMenuShortcut as ShadcnContextMenuShortcut,
  ContextMenuGroup as ShadcnContextMenuGroup,
  ContextMenuPortal as ShadcnContextMenuPortal,
  ContextMenuSub as ShadcnContextMenuSub,
  ContextMenuSubContent as ShadcnContextMenuSubContent,
  ContextMenuSubTrigger as ShadcnContextMenuSubTrigger,
  ContextMenuRadioGroup as ShadcnContextMenuRadioGroup,
} from "src/shadcn/components/context-menu";

const ContextMenu = (props: React.ComponentProps<typeof ShadcnContextMenu>) => (
  <ShadcnContextMenu {...props} />
);

const ContextMenuTrigger = (
  props: React.ComponentProps<typeof ShadcnContextMenuTrigger>
) => <ShadcnContextMenuTrigger {...props} />;

const ContextMenuContent = (
  props: React.ComponentProps<typeof ShadcnContextMenuContent>
) => <ShadcnContextMenuContent {...props} />;

const ContextMenuItem = (
  props: React.ComponentProps<typeof ShadcnContextMenuItem>
) => <ShadcnContextMenuItem {...props} />;

const ContextMenuCheckboxItem = (
  props: React.ComponentProps<typeof ShadcnContextMenuCheckboxItem>
) => <ShadcnContextMenuCheckboxItem {...props} />;

const ContextMenuRadioItem = (
  props: React.ComponentProps<typeof ShadcnContextMenuRadioItem>
) => <ShadcnContextMenuRadioItem {...props} />;

const ContextMenuLabel = (
  props: React.ComponentProps<typeof ShadcnContextMenuLabel>
) => <ShadcnContextMenuLabel {...props} />;

const ContextMenuSeparator = (
  props: React.ComponentProps<typeof ShadcnContextMenuSeparator>
) => <ShadcnContextMenuSeparator {...props} />;

const ContextMenuShortcut = (
  props: React.ComponentProps<typeof ShadcnContextMenuShortcut>
) => <ShadcnContextMenuShortcut {...props} />;

const ContextMenuGroup = (
  props: React.ComponentProps<typeof ShadcnContextMenuGroup>
) => <ShadcnContextMenuGroup {...props} />;

const ContextMenuPortal = (
  props: React.ComponentProps<typeof ShadcnContextMenuPortal>
) => <ShadcnContextMenuPortal {...props} />;

const ContextMenuSub = (
  props: React.ComponentProps<typeof ShadcnContextMenuSub>
) => <ShadcnContextMenuSub {...props} />;

const ContextMenuSubContent = (
  props: React.ComponentProps<typeof ShadcnContextMenuSubContent>
) => <ShadcnContextMenuSubContent {...props} />;

const ContextMenuSubTrigger = (
  props: React.ComponentProps<typeof ShadcnContextMenuSubTrigger>
) => <ShadcnContextMenuSubTrigger {...props} />;

const ContextMenuRadioGroup = (
  props: React.ComponentProps<typeof ShadcnContextMenuRadioGroup>
) => <ShadcnContextMenuRadioGroup {...props} />;

export {
  ContextMenu,
  ContextMenuTrigger,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuCheckboxItem,
  ContextMenuRadioItem,
  ContextMenuLabel,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuGroup,
  ContextMenuPortal,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuRadioGroup,
};
